"use client";

import { ChevronDown } from "lucide-react";
import { Box } from "@/components/atoms/Box";
import { Text } from "@/components/atoms/Text";
import { RawButton } from "@/components/atoms/RawButton";

const HeroScrollButton = () => {
  const handleScroll = () => {
    window.scrollBy({ top: window.innerHeight, behavior: "smooth" });
  };

  return (
    <Box className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20">
      <RawButton
        onClick={handleScroll}
        className="group flex flex-col items-center gap-2 cursor-pointer text-white/50 hover:text-white transition-colors duration-300"
        aria-label="Scroll to content"
      >
        <Text className="text-xs font-bold uppercase tracking-ultra-wide opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          Scroll
        </Text>
        <Box className="animate-bounce rounded-full border border-white/20 p-2 backdrop-blur-sm group-hover:border-white/40 transition-colors">
          <ChevronDown className="size-6" />
        </Box>
      </RawButton>
    </Box>
  );
};

export { HeroScrollButton };
